const URLParams = new URLSearchParams(window.location.search);
export const getUrlParam = (name) => {
  return URLParams.get(name);
};
